import React, { useState } from 'react'

import { useCopy } from '@mondough/copy'

import { TabCreatorReferral } from '../utils'

export const ReferralContext = React.createContext({
  referralData: null as TabCreatorReferral | null,
  setReferral: (_referral: TabCreatorReferral | null) => {
    return
  },
  defaultReferralText: '' as string,
})

export const ReferralProvider = ({ children }: { children: JSX.Element }) => {
  const [referralData, setReferralData] = useState<TabCreatorReferral | null>(
    null,
  )
  const c = useCopy()
  const defaultReferralText = c.string({
    key: 'app_tabs_monzo_me.referral.default.description',
    message:
      'Automate bills. Organise how you spend. Save in clever new ways, all with a free Monzo current account.\n\nYour information from Monzo Split will be there when you join.\n\nTs&Cs apply.',
  })

  return (
    <ReferralContext.Provider
      value={{
        referralData,
        setReferral: setReferralData,
        defaultReferralText,
      }}
    >
      {children}
    </ReferralContext.Provider>
  )
}
